export class UserModel {
    id: number;
    userName: string;
    password: string;
    tempPassword: string;
    email: string;
    lastUpdate: Date;
    isDeleted: boolean;
    creatorID: number;
    updatorID: number;
    lastLoginDate: Date;
    createDate: Date;
    serviceTypePermissionID: number;
    phoneNo: string;
     tempRestorePassword: string;
     lastLoginTrialDate: Date;
     countLoginTrials: number;
     isBlocked: boolean;
     blockedDate: Date;
     canUnBlockUsers: boolean;
}


// WEBPACK FOOTER //
// ./src/app/_models/user.model.ts